import { createAsyncThunk } from '@reduxjs/toolkit';
import timeClockApi from '~/apis/timeclock';
import {
  CHECKIN_TIME_CLOCK,
  GET_TIME_CLOCK,
  GET_TIME_CLOCKS,
  GET_TIME_CLOCKS_SELECTION,
  UPDATE_TIME_CLOCK,
} from '~/utils/constants/actionType';
import {
  IEditTimeClock,
  IParamsGetTimeClockSelection,
  IParamsGetTimeClocks,
  IResponseGetTimeClocks,
  IResponseGetTimeClocksSelection,
  ITimeClock,
  ITimeClockEvent,
} from '~/utils/interface/timeClock';

export const handleGetTimeClocks = createAsyncThunk<IResponseGetTimeClocks, IParamsGetTimeClocks>(
  GET_TIME_CLOCKS,
  async (params: IParamsGetTimeClocks = {}, { rejectWithValue }) => {
    try {
      const res = await timeClockApi.getTimeClocks(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetTimeClocksSelection = createAsyncThunk<
  IResponseGetTimeClocksSelection,
  IParamsGetTimeClockSelection
>(GET_TIME_CLOCKS_SELECTION, async (params: IParamsGetTimeClockSelection = {}, { rejectWithValue }) => {
  try {
    const res = await timeClockApi.getSelection(params);

    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleGetTimeClock = createAsyncThunk<ITimeClockEvent, string>(
  GET_TIME_CLOCK,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await timeClockApi.getTimeClock(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCheckinTimeClock = createAsyncThunk<ITimeClock, IEditTimeClock>(
  CHECKIN_TIME_CLOCK,
  async (data: IEditTimeClock, { rejectWithValue }) => {
    try {
      const res = await timeClockApi.checkinTimeClock(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateTimeClock = createAsyncThunk<ITimeClock, { id: string; data: IEditTimeClock }>(
  UPDATE_TIME_CLOCK,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await timeClockApi.updateTimeClock(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
